import "vite/modulepreload-polyfill";
import { createRoot } from "react-dom/client";
import { TrendingProposalsWidget } from "./Components/TrendingProposalsWidget.jsx";

export function RenderTrendingProposals(configuration){
    const container = document.getElementById(configuration.container);
    const root = createRoot(container);

    root.render(
      (
        <TrendingProposalsWidget configuration={configuration} />
      ),
    );
}


document.addEventListener("DOMContentLoaded", function() {
    const widget_configs = document.querySelectorAll(".trending-proposals-widget-config");

    for (let config of widget_configs) {
        RenderTrendingProposals(JSON.parse(config.innerText));
    }
});
